import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class FirstBoardShareTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.FIRST_BOARD_SHARE;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLE_FIRST_BOARD_SHARE;

	get id(): string {
		return TourId.FIRST_BOARD_SHARE;
	}

	override get keyForPersistantDone(): string {
		return FirstBoardShareTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.DOWN,
				attachTo: () => {
					return this.el;
				},
				doAction: () => {
					// close
					this.end();
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}
}
